import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SectionProps } from '../utils/SectionProps';
import SectionHeader from '../components/sections/partials/SectionHeader';
import Button from '../components/elements/Button';

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

const Download = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor
}) => {
  const outerClasses = classNames(
    'signin section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'signin-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const sectionHeader = {
    title: 'Protected download area',
    paragraph: 'This page is only available when you are signed in.'
  };

  return (
    <section className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader tag="h1" data={sectionHeader} className="center-content" />
          <div className="tiles-wrap">
            <div className="tiles-item">
              <div className="tiles-item-inner has-shadow">
                <p className="mt-0 mb-24">
                  Your protected Exanta downloads or account-specific resources can live here.
                </p>
                <Button tag={Link} to="/account" color="primary" wide>
                  Back to Account
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Download.propTypes = propTypes;
Download.defaultProps = defaultProps;

export default Download;
